import Carga from './Carga'

export default Carga
